import { Button } from "../Button";
import s from "./ShowMore.module.scss";

/** The "Show 25 more" button under a card list. */
export const ShowMore = ({ label, onClick, loading }: { label: string; onClick: () => void; loading?: boolean }) => (
  <div className={s.wrap}><Button onClick={onClick} loading={loading} className={s.btn}>{label}</Button></div>
);
